var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-loading"},[_c('div',{staticClass:"loading"},[_c('b-spinner',{staticClass:"m-2",attrs:{"variant":"primary","role":"status"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }